import React from 'react';

import DataGrid from './DataGrid';

const DataTable = ({ columns, data, height, width, headerRef, stats, pageSize, loadMore }) =>
	data.length ? (
		<DataGrid
			data={data}
			visibleColumns={columns}
			height={height}
			width={width}
			headerRef={headerRef}
			stats={stats}
			pageSize={pageSize}
			loadMoreDataRows={loadMore}
		/>
	) : null;

export default DataTable;
